import { render, staticRenderFns } from "./reserveOrderList.vue?vue&type=template&id=0474dce0&scoped=true"
import script from "./reserveOrderList.vue?vue&type=script&lang=js"
export * from "./reserveOrderList.vue?vue&type=script&lang=js"
import style0 from "./reserveOrderList.vue?vue&type=style&index=0&id=0474dce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474dce0",
  null
  
)

export default component.exports